<template>
  <div class="print-detail">
    <div class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Current Local Retail Price Of {{ selectedCrop }}
      </AppHeading>
      <AppHeading element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <span>{{ retailPrice }}</span>
          <AppHeading :theme="theme" size="xs" class="align-bottom">
            <span>&nbsp;&nbsp;{{ cropUnit }}</span>
          </AppHeading>
        </div>
      </AppHeading>
    </div>
    <div class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Current Blend
      </AppHeading>
      <AppHeading element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <span>{{ selectedFertilizer.name }}</span>
        </div>
      </AppHeading>
    </div>
    <div class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Blend's Rate OF P₂O₅
      </AppHeading>
      <AppHeading element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <span>{{ rateOfPhosphorusApplied }}</span>
          <AppHeading :theme="theme" size="xs" class="align-bottom">
            <span>&nbsp;&nbsp;{{ convertedUnit }}</span>
          </AppHeading>
        </div>
      </AppHeading>
    </div>
    <div class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Blend's Sulfur Source
      </AppHeading>
      <AppHeading :theme="theme" element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <TextContent :content="selectedAmmoniumSulfateBlend.name" :keywords="selectedAmmoniumSulfateBlend.keywords" />
        </div>
      </AppHeading>
    </div>
    <div v-if="zincBlend" class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Blend's Zinc Source
      </AppHeading>
      <AppHeading :theme="theme" element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <TextContent :content="zincBlend.displayText" />
        </div>
      </AppHeading>
    </div>
    <div v-if="performanceProductFormula === 'microessentials-sz'" class="print-detail__row">
      <AppHeading theme="black" element="h2" size="xs" spacing="xs">
        Rate Of Zinc Applied
      </AppHeading>
      <AppHeading element="h2" size="sm" spacing="sm">
        <div class="print-detail__value">
          <span>{{ rateOfZincApplied }}</span>
          <AppHeading :theme="theme" size="xs" class="align-bottom">
            <span>&nbsp;&nbsp;{{ convertedUnit }}</span>
          </AppHeading>
        </div>
      </AppHeading>
    </div>
  </div>
</template>

<script>
import AppHeading from '@/components/shared/AppHeading';
import TextContent from '@/components/shared/TextContent';

export default {
  components: {
    TextContent,
    AppHeading
  },
  // filters: {
  //   currency(value) {
  //     return `$${Number(value).toFixed(2)}`;
  //   }
  // },
  props: {
    performanceProductFormula: {
      type: String,
      required: false,
      default: ''
    },
    selectedFertilizer: {
      type: Object,
      required: true
    },
    selectedCrop: {
      type: String,
      required: true
    },
    rateOfPhosphorusApplied: {
      required: false,
      type: [Number, String],
      default: ''
    },
    rateOfZincApplied: {
      required: false,
      type: [Number, String],
      default: ''
    },
    cropYield: {
      required: false,
      type: [Number, String],
      default: ''
    },
    retailPrice: {
      required: false,
      type: [Number, String],
      default: ''
    },
    selectedAmmoniumSulfateBlend: {
      required: false,
      type: Object,
      default: null
    },
    theme: {
      type: String,
      required: false,
      default: 'primary',
      validator: value => ['black', 'gold', 'gray', 'light', 'primary', 'white'].includes(value)
    },
    weightOption: {
      required: true,
      type: String,
      default: null
    },
    zincBlend: {
      required: false,
      type: Object,
      default: null
    }
  },
  computed: {
    cropUnit() {
      return '/' + this.weightOption.split('/')[0].toUpperCase();
    },
    convertedUnit() {
      if (this.weightOption === 'bu/ac' || this.weightOption === 'lb/ac') {
        return 'LBS/AC';
      }
      return 'KG/HA';
    }
  }
};
</script>

<style lang="scss">
.print-detail {
  &__row {
    margin-bottom: spacing('xl');
  }

  &__value {
    // @include font-size('paragraph', 'lg');
    display: flex;
    flex-direction: row;
  }
}
</style>
